import { render, staticRenderFns } from "./AboutPartial.htm?vue&type=template&id=83b7237a&scoped=true&external"
import script from "./AboutPartial.js?vue&type=script&lang=js&external"
export * from "./AboutPartial.js?vue&type=script&lang=js&external"
import style0 from "./AboutPartial.scss?vue&type=style&index=0&id=83b7237a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b7237a",
  null
  
)

export default component.exports